import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";


export function NoDashboard() {
    useEffect(() => {
        document.title = "Z Freedom";
    }, [])
    return (
        <>
            <Row>
                <Col xl={12}>
                    <div className="page-title-box">
                        <h4 className="page-title">Dashboard</h4>
                        You do not have permission to view
                    </div>
                </Col>
            </Row>

        </>
    );
}

